/**
 * Base PDF width used for field coordinate calculations.
 * Fields are positioned in this coordinate space; the actual rendered
 * width is `BASE_PDF_WIDTH * zoom`.
 */
export const BASE_PDF_WIDTH = 700;

/**
 * Returns default width/height for a signing field based on its type.
 * Used by TemplateBuilder (when adding fields) and PdfViewer (for layout).
 */
export function getFieldDimensions(fieldType: string): { width: number; height: number } {
  switch (fieldType) {
    case 'SIGNATURE': return { width: 250, height: 80 };
    case 'INITIALS': return { width: 120, height: 60 };
    case 'CHECKBOX': return { width: 24, height: 24 };
    case 'DATE_SIGNED': return { width: 140, height: 28 };
    case 'DATE': return { width: 140, height: 28 };
    case 'NUMBER': return { width: 120, height: 28 };
    case 'PHONE': return { width: 250, height: 28 };
    case 'CURRENCY': return { width: 220, height: 28 };
    case 'DROPDOWN': return { width: 180, height: 28 };
    default: return { width: 150, height: 28 };
  }
}
